<template>
  <table-view v-loading='loading' :show-page='false'>
    <template #header>
      <view-search-form
        :queryInfo.sync='tableQuery'
        :tool-list="['grade', 'college', 'major']"
        @on-search='renderTable(1)' />
      <div class="header-button">
        <el-dropdown @command="handleCommand">
          <el-button type="success" size="small">按条件导出<i
            class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="bachelorIntention">普通专升本意向
            </el-dropdown-item>
            <el-dropdown-item command="noBachelorIntention">暂无意向
            </el-dropdown-item>
            <el-dropdown-item command="bachelorIntentionSchool">自学专升本意向
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tag class="ml-1">普通专升本意向人数：{{ summaryInfo.hasBachelorIntentionCount || 0 }}</el-tag>
        <el-tag class="ml-1 mr-1">暂无意向人数：{{ summaryInfo.noBachelorIntentionCount || 0 }}</el-tag>
        <el-tag>自学专升本意向人数：{{ summaryInfo.bachelorIntentionSchool || 0 }}</el-tag>
      </div>
    </template>
    <!-- body -->
    <el-table :data='tableData' style='width: 100%' border stripe>
      <el-table-column prop='bachelorIntentionSchool' label='意向学校' />
      <el-table-column prop='bachelorIntentionMajor' label='意向专业' />
      <el-table-column prop='stuNum' label='意向人数' />
    </el-table>
    <!--    自定义导出字段 dialog -->
    <DialogExportStuSelect :visible.sync="visibleDIYExportDialog" v-if="visibleDIYExportDialog"
                           :student-columns="studentColumns"
                           :check-list="initCheckList"
                           :dialog-title="exportTitle"
                           :query-info="tableQuery" />
  </table-view>
</template>

<script>
import { getHigherSchoolCount } from '@/api/count'
import tableView from '@/vue/mixins/table-view'
import DialogExportStuSelect from '@/components/common/components/DialogExportStuSelect.vue'

export default {
  components: { DialogExportStuSelect },
  mixins: [tableView],
  data() {
    return {
      exportTitle: '导出学生名单-表头筛选',
      visibleDIYExportDialog: false, // 自定义字段导出学生
      // 表格字段
      initCheckList: ['bachelorIntentionSchool', 'bachelorIntentionMajor'],
      //  统计信息
      summaryInfo: {
        hasBachelorIntentionCount: 0, // 有意向
        noBachelorIntentionCount: 0, // 无意向
        bachelorIntentionSchool: 0 // 自学
      },
      tableQuery: {
        bachelorIntention: 0,
        bachelorIntentionSchool: 0,
        campusId: null,
        grade: new Date().getFullYear(),
        collegeId: null,
        majorId: null
      },
      stuStatus: this.$store.state.systemParam.stuStatus,
      stuInfo: [],
      studentColumns: [...this.$store.state.systemParam.studentColumns, {
        prop: 'bachelorIntention',
        label: '是否有普通专升本意向',
        width: '130'
      }]
    }
  },
  created() {
    const defaultCheckList = ['stuNo', 'grade', 'collegeName', 'majorName', 'stuName', 'bachelorIntentionSchool', 'bachelorIntentionMajor', 'managerUserName', 'bachelorIntention']
    window.localStorage.setItem(this.$route.name + ':exportStuKeys', JSON.stringify(defaultCheckList))
  },
  methods: {
    // 获取学生列表
    async renderTable(pageNum) {
      this.loading = true
      try {
        const { data } = await getHigherSchoolCount(this.tableQuery)
        this.tableData = data.countBachelorIntentionVos
        this.summaryInfo = data
        this.total = data.total
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'bachelorIntention':
          this.exportTitle = '导出学生名单-普通专升本意向'
          // 有意向
          this.tableQuery.bachelorIntention = 1
          this.tableQuery.bachelorIntentionSchool = null
          break
        case 'noBachelorIntention':
          this.exportTitle = '导出学生名单-暂无意向'
          // 无意向
          this.tableQuery.bachelorIntention = 0
          this.tableQuery.bachelorIntentionSchool = null
          break
        case 'bachelorIntentionSchool':
          this.exportTitle = '导出学生名单-自学专升本意向'
          // 自学
          this.tableQuery.bachelorIntention = null
          this.tableQuery.bachelorIntentionSchool = 1
          break
      }
      this.visibleDIYExportDialog = true
    }
  }
}
</script>
